<span class="filter-label" id="filter-status-label">Status</span>

<!-- Named by the static label plus the live summary — an aria-label would
     REPLACE the visible All / <status> / "N selected" text in the
     accessibility tree, hiding the current selection from a screen reader. -->
<button
  #statusToggle
  type="button"
  class="status-toggle"
  data-testid="filter-status"
  aria-labelledby="filter-status-label filter-status-summary"
  [attr.aria-expanded]="open()"
  [attr.aria-controls]="open() ? panelId : null"
  (click)="toggleOpen()"
>
  <span class="status-summary" id="filter-status-summary">{{ summary() }}</span>
  <fa-icon [icon]="chevronIcon" aria-hidden="true" />
</button>

@if (open()) {
  <div class="status-panel" [id]="panelId">
    <fieldset class="status-fieldset">
      <legend>Status</legend>
      @for (status of statusValues; track status) {
        <div class="status-row">
          <input
            type="checkbox"
            [id]="checkboxId(status)"
            [attr.data-testid]="'filter-status-' + status"
            [value]="status"
            [checked]="isChecked(status)"
            (change)="onCheckboxChange(status, $event)"
          />
          <label [attr.for]="checkboxId(status)">{{ status }}</label>
        </div>
      }
    </fieldset>
    <p class="status-note">Status is a fixed three-value set.</p>
  </div>
}
